export const links = {
  RGCams: "http://go.goaserv.com/redirect.go?pid=390&spaceid=1244532",
};
